module.exports = __webpack_public_path__ + "static/Chamu Rajasekera.131d9408.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mentors/Chamu Rajasekera.jpg
// module id = 1207
// module chunks = 6166952557895